export const KASPI_DETECT_COOKE = 'is_mobile_app'
export const KASPI_VERSION_COOKE = 'ma_ver'
export const KASPI_LANGUAGE_COOKE = 'locale'
